import { Observable } from 'rxjs';

import { BillingInfo } from '../models/billing-body.model';
import { BillingResponse } from '../models/billing-response.model';

export abstract class BillingRepository {
    abstract sendUserData(): Observable<BillingResponse>;

    abstract storeBilling(billingData: BillingInfo): Observable<boolean>;
}
